import { Range, Editor } from 'slate';
import { isHeading, Type } from '../HeadingPlugin.mjs';
import { findAllNodesSafe } from '../../../../../core/queries/findNode.mjs';
import { isElement } from '../../../../../core/utilities/nodes/elements/isElement.mjs';

/**
 * Returns the heading type of the current selection.
 * Returns `null` when there are mixed text types selected.
 * Returns defaultBlockType when there is no selection or the selection is the defaultBlockType
 */
function findHeadingType(editor, at = editor.selection, defaultBlockType) {
  let location = at;
  if (Range.isRange(location)) {
    location = Editor.unhangRange(editor, location);
  }
  if (!location) {
    return defaultBlockType;
  }
  const selectedTextBlockLevels = Array.from(findAllNodesSafe(editor, {
    at: location,
    match: node => isElement(node) && (node.type === Type || node.type === defaultBlockType)
  })).map(([node]) => isHeading(node) ? node.level : defaultBlockType);
  if (!selectedTextBlockLevels.length) {
    return defaultBlockType;
  }
  const selectedLevel = selectedTextBlockLevels[0];
  return selectedTextBlockLevels.every(level => level === selectedLevel) ? selectedLevel : null;
}

export { findHeadingType };
